import React from 'react';
import { IconProps } from '../types';
const MinecraftLeatherChestplateOverlay: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">

</svg>);
export default MinecraftLeatherChestplateOverlay;